import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/core/services/api/bitf-api.service';

@Injectable({
  providedIn: 'root',
})
export class NeedsService extends BitfApiService {
  constructor(protected injector: Injector) {
    super('need', injector);
  }
}
